import { formatComptableMaisPasTrop } from "../../../services/function";
import { useProductionStore } from "../../../stores/production";

const ProductionByDepartment = () => {
  const { production2 } = useProductionStore();

  return (
    <table className="min-w-full font-Nunito bg-white shadow-lg border border-gray-100 rounded-2xl h-auto overflow-x-scroll overflow-y-scroll">
      <thead>
        <tr className="h-12">
          <th className="border border-gray-300 px-4 py-2 bg-thead text-left w-72">
            Départements
          </th>
          <th className="border border-gray-300 px-4 py-2 bg-thead text-left">
            Production (euro)
          </th>
          <th className="border border-gray-300 px-4 py-2 bg-thead text-left">
            Facturation (euro)
          </th>
          <th className="border border-gray-300 px-4 py-2 bg-thead text-left">
            Taux horaire moyen
          </th>
          <th className="border border-gray-300 px-4 py-2 bg-thead text-left">
            Taux facturé moyen
          </th>
        </tr>
      </thead>
      <tbody>
        {production2?.departmentsValues?.map((row: any) => (
          <tr key={row.id} className="h-8 ">
            <td className="border border-gray-300 px-4 py-2 text-left w-72">
              {row.name}
            </td>
            <td className="border border-gray-300 px-4 py-2 text-left">
              {formatComptableMaisPasTrop(row.totalTimesAmount)}
            </td>
            <td className="border border-gray-300 px-4 py-2 text-left">
              {formatComptableMaisPasTrop(row.totalAmount)}
            </td>
            <td className="border border-gray-300 px-4 py-2 text-left">
              {row?.averageHourlyRate?.toFixed(2) || ""}
            </td>
            <td className="border border-gray-300 px-4 py-2 text-left">
              {row?.averageInvoicedHourlyRate?.toFixed(2) || ""}
            </td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr className="border-gray-300 bg-gray-200 h-8 w-full">
          <td className="border border-gray-300 px-4 py-2 text-left w-44">
            Total
          </td>
          <td className="border border-gray-300 px-4 py-2 text-left">
            {" "}
            {formatComptableMaisPasTrop(
              production2?.totals?.totalInvoicesTimesAmount
            )}
          </td>
          <td className="border border-gray-300 px-4 py-2 text-left">
            {formatComptableMaisPasTrop(production2?.totals?.totalAmount)}
          </td>
          <td className="border border-gray-300 px-4 py-2 text-left"></td>
          <td className="border border-gray-300 px-4 py-2 text-left"></td>
        </tr>
      </tfoot>
    </table>
  );
};

export default ProductionByDepartment;
